<template>
  <div
    id="modalDeleteAction"
    class="modal fade"
    tabindex="-1"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Excluir Ação</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            &times;
          </button>
        </div>
        <form @submit.prevent="deleteAction">
          <div class="modal-body">
            <p>Deseja realmente excluir está ação?</p>
            <p>
              <strong>Atenção:</strong> Este processo não poderá ser desfeito!
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-danger"
              title="Excluir"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span v-else>Excluir</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteActionModal',

  props: {
    registryId: {
      type: String,
      required: true,
    },
    actionId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      disableButton: false,
    }
  },

  methods: {
    async deleteAction() {
      this.disableButton = true
      try {
        const response = await this.$store.dispatch('deleteAction', {
          registryId: this.registryId,
          actionId: this.actionId,
        })
        this.disableButton = false
        window.$('#modalDeleteAction').modal('hide')
        this.$emit('closeModal', true)
        this.$snotify.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },
  },

  mounted() {
    window.$('#modalDeleteAction').modal()
  },
}
</script>
